import clsx from "clsx";

import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import { JobTypeBadge } from "@/features/job/components/jobList/JobTypeBadge";
import { jobTypes } from "@/features/job/const/jobTypes";
import {
  JobOrderByWithRelationInput,
  JobTypeEnum,
  JobWhereInput,
} from "@/generated/graphql-hooks";

const jobTypeFilterList = ["", ...Object.keys(jobTypes)] as JobTypeEnum[];

export const JobTypeDesktopFilter = () => {
  const { query, setWhere } = useRequestQuery<
    JobWhereInput,
    JobOrderByWithRelationInput
  >();

  return (
    <div className="space-y-2">
      {jobTypeFilterList.map((jobType, index) => {
        const selected =
          query?.where?.jobType?.equals === jobType ||
          (!query?.where?.jobType?.equals && !jobType);

        return (
          <div
            className={clsx(
              selected ? "bg-primary" : "bg-transparent",
              "flex cursor-pointer items-center rounded",
            )}
            onClick={() => {
              const { jobType: prev, ...rest } = query.where;
              setWhere({
                ...rest,
                ...(!!jobType && { jobType: { equals: jobType } }),
              });
            }}
            key={index}
          >
            <JobTypeBadge
              size="md"
              className={clsx(
                selected ? "!text-white" : "!text-gray-500",
                "!space-x-3 !bg-transparent !text-base !font-light",
              )}
              labelClassName={selected ? "text-white" : "text-gray-900"}
              jobType={jobType}
            />
          </div>
        );
      })}
    </div>
  );
};
